import { UserInformation } from '@ha/api/v2/types/UserInformation';

export type UserInfoResponse = UserInformation & {
  hasCompleteBillingInformation?: boolean;
};

export enum AuthType {
  login = 'login',
  register = 'register',
}
